import React, { useEffect, useState } from "react";
import { Button, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import NumberInput from "./NumberInput.jsx";
import instance from "../../Utils/api.js";
import Delete from "../assets/icons/delete.svg";
import "../styles/pages/profile.scss";
import Image from "../../Utils/getImage.js";

const Cartproduct = ({
  data,
  showCheckbox,
  showCheckbox1,
  setSelectedData,
  getCartData,
  selectedData,
}) => {
  const handleCheckboxChange = (event, data) => {
    if (event.target.checked) {
      setSelectedData((prevIds) => [...prevIds, data]);
    } else {
      setSelectedData((prevIds) =>
        prevIds.filter((selectedId) => selectedId?._id !== data?._id)
      );
    }
  };

  const updateQuantity = async (itemId, quantity) => {
    try {
      await instance.patch(
        `/Cart/updateItemQuantity?item_id=${itemId}&quantity=${quantity}`
      );
      data.quantity = quantity;
      getCartData();
    } catch (error) {
      console.log(error);
    }
  };

  const deleteProduct = async (itemId) => {
    try {
      await instance.delete(`/Cart/removeFromCart?item_id=${itemId}`);
      getCartData();
    } catch (error) {
      console.log(error);
    }
  };


  return (
    <React.Fragment>
      <div className="mycart-details">
        {showCheckbox === false ? null : (
          <div className="item-checked">
            <Checkbox
              onChange={(event) => handleCheckboxChange(event, data)}
              checked={selectedData?.some((item) => item?._id === data?._id)}
            />
          </div>
        )}
        <div className="product-image">
          <Image
            src={data?.design_id?.picture[0]}
            alt="orderimage"
            width={150}
            height={160}
          />
        </div>
        <div className="product-description">
          <div className="main-product-content">
            <div className="product-content">
              <Typography variant="h5">
                <span> Design Name:</span> {data?.design_kind === "CustomDesign"
                  ? (data?.name || "---")
                  : (data?.design_id?.name || "---")}
                {data?.design_kind === "CustomDesign" ? "(Custom Design)" : ""}


              </Typography>
              <Typography>
                <span>Description :</span> {data?.design_id?.description || "---"}
              </Typography>
              <Typography>
                <span>size:</span> {data.size || "---"}
              </Typography>
              <Typography><span>Price :</span> {data?.design_id?.price || "---"}</Typography>
            </div>
            {showCheckbox === false ? null : (
              <div className="product_remove">
                <Button
                  endIcon={<img src={Delete} alt="Delete" />}
                  onClick={() => {
                    deleteProduct(data?._id);
                  }}
                >
                  Delete
                </Button>
              </div>
            )}
          </div>
          <div className="product-numberInput quantity_text">
            {showCheckbox === false ? (
              <Typography>
                <span>Quantity :</span> {data?.quantity}
              </Typography>
            ) : (
              <NumberInput
                value={data?.quantity}
                // disabled={!showCheckbox}
                onChange={(event, newValue) => {
                  if (newValue >= 1 && newValue <= 100) {
                    updateQuantity(data?._id, newValue);

                    setSelectedData((prev) =>
                      prev.map((item) =>
                        item?._id === data?._id ? { ...item, quantity: newValue } : item
                      )
                    );
                  }
                }}
                min={1}
                max={100}
              />
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Cartproduct;
